if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/service-worker.js', { scope: './' })
    .then(function(reg) {
      console.log('[Page] Service worker registered!')
    })
}

import Rails from 'rails-ujs'
import MicroModal from 'micromodal'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import Flash from './components/Flash'
import MainHeroSlider from './components/MainHeroSlider'
import Accordion from './components/Accordion'
import LoginPanel from './components/LoginPanel'
import EventsPreview from './components/EventsPreviews'
// import SocialSlider from './components/SocialSlider'
import PartnersSlider from './components/PartnersSlider'
import RelatedCoursesSlider from './components/RelatedCoursesSlider'
import GlobalSearch from './components/GlobalSearch'
import {AssesmentManager} from './components/AssesmentManager'
import Dashboard from './components/Dashboard'
import MapLocator from './components/MapLocator'
import AnimationManager from './components/AnimationManager'
import EventsSearch from './components/EventsSearch'
import Search from './components/Search'
import SkewHeroSlider from './components/SkewHeroSlider'
import Tickets from './components/Tickets'
import VideoManager from './components/VideoManager'
import VideoAppSlider from './components/App'
import LightBox from './components/Lightbox'
import InputFile from './components/InputFile'
import UniversitySelector from './components/UniversitySelector'
import PathwaysSelector from './components/PathwaysSelector'
import CourseSelector from './components/CourseSelector'
import EventSelector from './components/EventSelector'
import NewsletterForm from './components/NewsletterForm'
import TrainingPlanManager from './components/TrainingPlanManager'
import Form from './components/Form'
import { inizializzaBannerSconto, inizializzaBannerCookie } from './components/Altro'

// test modular pattern
import { sidebarSlider, testimonialSlider } from './components/Sliders'
import { testimonialsGrid } from './components/Grid'

import { debounce, getSreenSizes } from './util'
import { Hamburger, MobileMenu, DashboardSidebarToggle } from './components/Navigation';
import MapTable from './components/MapTable';

window.Flash = Flash
window.Dashboard = Dashboard

const startTippy = () => {
  if (getSreenSizes().width <= 768) return
  const selectors = document.querySelectorAll('.js-tippy')
  if (!selectors || selectors.length < 1) return

  selectors.forEach((selector) => {
    tippy(selector)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className = 'js'

  window.authParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content')
  window.authToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  const metaLanguage = document.querySelector('meta[name="language"]')
  const metaRoutes = document.querySelector('meta[name="routes"]')
  if (metaLanguage) {
    window.language = metaLanguage.getAttribute('content')
  }
  if (metaRoutes) {
    window.routes = JSON.parse(metaRoutes.getAttribute('content'))
  }

  startTippy()

  Rails.start()

  inizializzaBannerCookie.init()
  inizializzaBannerSconto.init()

  Hamburger.init()
  DashboardSidebarToggle.init()
  MicroModal.init({ disableScroll: true })
  Flash.init()
  EventsPreview.init()
  LoginPanel.init()
  AssesmentManager.init()
  GlobalSearch.init()
  Dashboard.init()
  MapLocator.init()
  AnimationManager.init()
  EventsSearch.init()
  Search.init()
  Tickets.init()
  VideoManager.init()
  VideoAppSlider.init()
  LightBox.init()
  UniversitySelector.init()
  PathwaysSelector.init()
  CourseSelector.init()
  EventSelector.init()
  InputFile.init()
  NewsletterForm.init()
  TrainingPlanManager.init()
  Form.init()
})

window.addEventListener('resize', debounce(() => {
  MobileMenu.resize()
  MapTable.resize()
}, 250))

window.addEventListener('load', () => {
  MobileMenu.init()
  MainHeroSlider.init()
  // SocialSlider.init()
  PartnersSlider.init()
  RelatedCoursesSlider.init()
  testimonialSlider.init()
  SkewHeroSlider.init()
  sidebarSlider.init()
  testimonialsGrid.init()
  Accordion.init()
})



// WEBPACK FOOTER //
// app/javascript/scripts/main.js